<template>
  <v-content :class="{'apercu': $route.path==='/' && user.loggedIn }">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </v-content>
</template>

<script>
import {
  mapGetters
} from 'vuex'

export default {
  metaInfo () {
    return {
      title: 'Plafond et mur tendus NEWMAT Annecy'
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>

<style lang="scss">
strong{
  font-size: 16px !important;
  font-weight: 700 !important;
}
#core-view {
  padding-bottom: 100px;
}
.v-application--wrap .v-content{
  @media screen and (max-width: 550px) {
    padding-top: 0px !important;
  }
}

.apercu.v-content{
  @media screen and (min-width: 990px) {
    padding: 72px 0px 0px 0px !important;
    padding-top: 0 !important;
  }
}
.v-content.contenuapp{
  padding-top: 70px !important;
}

header#core-toolbar.v-app-bar {
  @media screen and (max-width: 550px){
    height: 20px !important;
  }
}
.v-app-bar {
  @media screen and (max-width: 550px){
    height:100px !important;
    padding-top: 5px;
  }
  .v-toolbar__content{
    .v-toolbar__items{
      @media screen and (max-width: 550px){
        padding-top: 5px;
      }
      .v-btn{
        margin: 0 0 !important;
        padding: 0 12px;
        @media screen and (max-width: 820px){
          font-size: 0.7em;
          padding: 0 8px;
        }
      }
    }
  }
}
.apercu {
  .v-content{
    padding-top: 84px !important;
    padding-bottom: 0 !important;
    padding-right: 0 !important;
    @media screen and (min-width: 990px) {
      padding-top: 140px !important;
      padding-left: 260px !important;
    }
    @media screen and (max-width: 550px){
      padding-top: 170px !important;
    }
  }
  .v-app-bar {
    margin-top: 70px !important;
    @media screen and (max-width: 550px){
      margin-top: 70px !important;
    }
    @media screen and (min-width: 990px) {
      margin-left: 260px !important;
    }
  }
}
</style>
